const $window = $(window);
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 768px)');

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// headerToggle
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

import {scrollAnimation} from "../include/module";
$(window).on('load', function(){
  setTimeout(function () {
    scrollAnimation();
    swiper();
  }, 100);
});
$(window).on('scroll', function(){
  scrollAnimation();
});


/*-------------------------------------------------------------------*/
/* swiper */
/*-------------------------------------------------------------------*/
const swiper = () => {
  var galleryThumbs = new Swiper('.swiper-sub', {
    // spaceBetween: 10,
    // slidesPerView: 10,
    // freeMode: true,
    // watchSlidesProgress: true,
    watchSlidesVisibility: true,
    allowTouchMove: false,
  });
  var galleryTop = new Swiper('.swiper-main', {
    // spaceBetween: 10,
    loop: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
}



// WEBPACK FOOTER //
// ./src/mobpsycho3rd/assets/js/goods/script.js